/**
 * Renders a `ProjectFileVersion.versionNumber` as the user-visible label —
 * the integer when it's a positive number, "?" otherwise.
 *
 * The OpenAPI generator narrows the nullable `versionNumber` field to
 * `{ [key: string]: unknown } | undefined` rather than `number | null`, so
 * the input is typed as `unknown` and coerced defensively at the boundary.
 */
export function formatVersionLabel(versionNumber: unknown): string {
  const num = Number(versionNumber ?? 0);
  return num > 0 ? String(num) : '?';
}
